import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import bannerImg1 from '../../assets/media/promotional_images/1693569308.webp';
import bannerImg2 from '../../assets/media/promotional_images/1693569534.webp';
import apiClient from '../../utils/api-client';
import BagsForLadies from './BagsForLadies';
import Categories from './Categories';
import FeaturedProducts from './FeaturedProducts';
import GuaranteedProd from './GuaranteedProd';
import './HomePage.css';
import PromoBanner from './PromoBanner';
import Slider from './Slider';
import StoreDetail from './StoreDetail';
import YouMayAlsoLikeProducts from './YouMayAlsoLikeProducts';
const HomePage = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [guaranteedProducts, setGuaranteedProducts] = useState([]);
  const [ladiesBagProducts, setLadiesBagProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const fetchFeaturedProducts = () => {
      apiClient
        .get('/is-featured')
        .then((response) => {
          setFeaturedProducts(response.data.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setIsLoading(false);
        });
    };

    const fetchGuaranteedProducts = () => {
      apiClient
        .get('/price/products?product_price=200')
        .then((response) => {
          setGuaranteedProducts(response.data.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setIsLoading(false);
        });
    };

    const fetchLadiesBagProducts = () => {
      apiClient
        .get('/subcategory/handbags')
        .then((response) => {
          setLadiesBagProducts(response.data.data.products);
        })
        .catch((error) => {
          setError(error.message);
        });
    };
    fetchFeaturedProducts();
    fetchGuaranteedProducts();
    fetchLadiesBagProducts();
  }, []);

  return (
    <>
      <Helmet>
        <title>Explore the Best Online Shopping Website in Pakistan </title>
        <meta
          name="keywords"
          content="creative items,unique items,creative items to sell,creative craft items,creative gift items,creative home decor products,unique home accessories,best home decor gifts,unique kitchen decor,unique modern home decor,unique decorative items,unique house accessories,cheap home decor gifts,unique kitchen products,unique kitchenware itemsunique kitchen items,home and kitchen unique products,unique kitchen accessories,unique kitchen tools"
        />
        <meta
          name="description"
          content="Discover a curated collection of top-quality products on the best online shopping website in Pakistan. Enjoy a seamless shopping experience with a wide range of categories and secure payment options."
        />
      </Helmet>

      {/* Hero Section */}
      <section>
        <div className="row">
          <div className="col-12 mt-2">
            <div className="h-100 w-100 ">
              <Slider />
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="pt-3">
        <Categories />
      </section>

      {/* Featured Products Section */}
      <section className="featured_product_section pt-3">
        <FeaturedProducts
          error={error}
          featuredProducts={featuredProducts}
          isLoading={isLoading}
        />
      </section>

      {/* Ladies Bag Products Section */}
      <section className=" pt-3">
        <BagsForLadies
          ladiesBagProducts={ladiesBagProducts}
          isLoading={isLoading}
          error={error}
        />
      </section>

      {/* Promo Banner Section */}
      <section className="banner_section pt-3 d-sm-block d-none">
        <PromoBanner bannerImg1={bannerImg1} bannerImg2={bannerImg2} />
      </section>

      {/* Price guaranteed Products Section */}
      <section className="price_grnted_product_section pt-3">
        <GuaranteedProd
          guaranteedProducts={guaranteedProducts}
          error={error}
          isLoading={isLoading}
        />
      </section>

      {/* Random (You mayb Also like) Products Section */}
      <YouMayAlsoLikeProducts />

      {/* Store Details Section */}
      <section className="store_details_section mt-3">
        <StoreDetail />
      </section>
    </>
  );
};
export default HomePage;
